import React, { useEffect, useRef, useState } from 'react';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {useContentGeneration} from "../hooks/useContentGeneration"
import {LineWave,ThreeDots} from "react-loader-spinner";
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useContentsContext } from "../hooks/useContentsContext";
import {useAuthContext} from '../hooks/useAuthContext';
import { useNavigate } from "react-router-dom";
import { MdOutlinePlayCircleFilled, MdOutlineClose, MdOutlinePauseCircleFilled, MdDeleteOutline, MdOutlineCloudDownload ,MdOutlinePlayArrow, MdOutlinePause } from "react-icons/md";
import { FaVolumeDown , FaVolumeMute} from "react-icons/fa";
import { TbRewindForward5 } from "react-icons/tb"
import { TbRewindBackward5 } from "react-icons/tb";
import { saveAs } from 'file-saver';
import {useSubscription} from "../hooks/useSubscription";
import { useLogout } from '../hooks/useLogout';

function TTS() {

  
    const[topic,setTopic] = useState();
    // const[result,setResult] = useState();
    const {user,dispatch} = useAuthContext()
    const navigate = useNavigate()
const { dispatchcontent,contents } = useContentsContext()
  const[data,setData] = useState(false);
  const[audioPlay,setAudio] = useState();
  const[text,setText] = useState();
  const[error,setError] = useState();

  const{subsInfo} = useSubscription()
const {logout}  = useLogout();
  var[progressBar,setProgressBar] = useState();
  const clickRef = useRef();
  var[isPlaying,setIsPlaying]=useState(false);
  const[duration,setDuration] = useState();
  const audioElem  = useRef();
  const[currentTime,setCurrentTime] = useState();
  const[isMuted,setisMuted] = useState(false);
  const[player,setPlayer] = useState("none")
const[voice,setVoices] = useState();
  const[spec,setSpec] = useState();
  const[chooseAudio,selectAudio] = useState("21m00Tcm4TlvDq8ikWAM")
  const[ringg,setRingg] = useState("")
  const[load,setLoad] = useState(false)
  // const[deleteMe,setDeleteMe] = useState();
    //get the function
    const {sendTexttoSpeech,fetchTTS,fetchVoices} = useContentGeneration()

    // event handler

  
  
 



  async  function  texttospeech(e){
       e.preventDefault()
      //send the topic and fpp
      setData(true)
      const data = {topic:topic,voice_id:chooseAudio}
      const response = await sendTexttoSpeech(data)
      setData(false)
       if(response.status !==200){
        const json = await response.json();
        setError(json.error)
       }else{
        const json = await response.json();
        setAudio(json.url)
        setText(json.text)
        setPlayer(true)
        //  fetchAudio()
       }
   }

    const fetchVoice = async() =>{
   setLoad(true)
    const voi = await fetchVoices()
    setVoices(voi)
    setLoad(false)
   
  }


    function playAudio(audio,text,nu,specific){
   setAudio(audio)
   setText(text)
   setPlayer(nu)
   setSpec(specific)
   setIsPlaying(!isPlaying)



   }

   function playPause(){
      setIsPlaying(!isPlaying)

   }

   
function onPlaying(){
  
    const duration = audioElem.current.duration;
    setDuration(duration)
    const ct = audioElem.current.currentTime;
    setCurrentTime(ct);
    setProgressBar({audioPlay, "progress" : ct/duration *100,"length":duration})
    if(ct === duration){
      setIsPlaying(false)
    }

  
}

const checkWidth = (e) =>{
let width = clickRef.current.clientWidth;
const offset = e.nativeEvent.offsetX;
const divProgress = offset/width * 100;
audioElem.current.currentTime = divProgress /100 * progressBar.length;
}


const handleVolume = ()=>{
     setisMuted(!isMuted)
     audioElem.current.muted = !isMuted;
}


const forwardBy5 = ()=>{
  const ct = audioElem.current.currentTime;
 var forward5 =  ct+5
 audioElem.current.currentTime = forward5;
}

const backwardBy5 = ()=>{
  const ct = audioElem.current.currentTime;
 var backward5 =  ct-5
 audioElem.current.currentTime = backward5;
}

const fixAudio = (audio_id) =>{
    
  selectAudio(audio_id)
  setSpec(audio_id)
  setRingg("ring ring-gray-400")

   
}



   const handleDelete = async (deleteMe) => {

  

    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history/tts/` + deleteMe, {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${user}`
        }

    })
    const json = await response.json()

    if (!response.ok) {
         setError(json.error)
    }
    if (response.ok) {
        dispatchcontent({ type: 'DELETE_AUDIO_CONTENTS', payload: json })
   
    }
}
const fetchAudio = async()=>{
  const audios = await fetchTTS();

  dispatchcontent({ type: 'FETCH_CONTENTS', payload: audios })

}


useEffect(() => {
  const users = Cookies.get('token')

  if(!users ){
    logout()
  }
if(isPlaying){
  audioElem.current.play();
}else{
      if(audioElem.current !== undefined){
        audioElem.current.pause();
      }
     

}

try{

  const User = jwtDecode(users)
  const checkToken = async() =>{
    const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
 
  if(!isExpired){
    fetchAudio()
    fetchVoice()
    // fetVo()
    // handleSubs()
    // fetchVoices()
  }else{
  
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
      method: 'GET',
      headers: {'Content-Type':'application/json',
  }
  })
 
if(response.status === 200){

   const json = await response.json()
  
   dispatch({ type: 'LOGIN', payload: json.token })
   navigate("/")
}else{
  logout()
}
  }

}
  


checkToken()
}catch(e){
  if(e.message.includes("Invalid token specified")){
    logout()
  }
  // console.log("logout")
  //   Cookies.remove("token")
  //   Cookies.remove("refresh_token")
  //   dispatch({ type: 'LOGOUT'})
}
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying])

if(user){
    return(

        <div className="min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mx-auto mb-10">
        
    {/* Modal for selecting AUdio */}
    


        <Tabs
              
              defaultActiveKey="talk"
              id="fill-tab-example"
              className="mt-5 mb-3 tab font-normal text-black"
              nav-justified
              nav-fill
            >
              <Tab eventKey="talk" title="Text to Speech">
            
              <div className="border p-5 mt-10 rounded-xl shadow-sm ">
                <div className='flex justify-between font-Rajdhani'>
               
                <div className='flex ' >

          
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-mic" viewBox="0 0 16 16">
  <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"/>
  <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3"/>
</svg>
            <h1 className="font-Rajdhani text-3xl ml-2 dark:text-white bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">Text to Speech </h1>

            </div>
            <p className=''>Usage: 
         
            {subsInfo && subsInfo.details ? subsInfo.details.audiochars : null}/{subsInfo && subsInfo.details ? subsInfo.details.totalaudiochars : null}
         

            </p>
                </div>
            <p className="font-Rajdhani text-xl ">Generate amazing audios from your text!</p>
         
    
            
            <div className="font-Rajdhani mt-10">
                <form onSubmit={texttospeech}>
                <label>What do you want to convert to audio?</label>
                <textarea className="w-full p-2  font-normal font-Rajdhani dark:bg-[#2e3247] border dark:border-0 dark:outline-blue-300 rounded-xl " placeholder="Simple ask or talk, Eg: How to start a startup?" onChange={(e)=>setTopic(e.target.value)} required maxLength={subsInfo && subsInfo.status!=='active'?100:500}/> 
                {subsInfo && subsInfo.details.audiochars >= subsInfo.details.totalaudiochars ?
                <p className='text-red-600 dark:text-red-400'>Upgrade to premium or wait for a month to continue generating text to speech.</p>
                : null}
                {subsInfo && subsInfo.status !== 'active' ?
                              <p className='text-sm'>{ `${topic ? topic.length : 0}`}/100</p>
:
<p className='text-sm'>{ `${topic ? topic.length : 0}`}/500</p>

              
              
              }
                <label>Select an audio</label>
                {load ? <ThreeDots  
                
                height="20"
  width="20"
  color='#dd412b'
  />  
  : null}
                <div className=" overflow-y-scroll h-[200px] p-1">






                <div className=' grid md:grid-cols-2 gap-2 text-sm mx-auto align-items-center  items-center'>
               

{voice && voice.map((v)=>(

<div className={`dark:bg-[#2e3247] border-1 shadow-md rounded p-1 md:flex m-0  items-center cursor-pointer dark:hover:ring dark:hover:ring-gray-400 ${ringg && spec === v.voice_id ? ringg : null}`} onClick={() => fixAudio(v.voice_id)} >



{isPlaying && currentTime !== duration && spec === v.voice_id ?
           <MdOutlinePauseCircleFilled  size={50} className='h-30 text-gray-600 dark:text-white' onClick={()=> playAudio(v.preview,v.name,"",v.voice_id)}/>
 :
 <MdOutlinePlayCircleFilled  size={50} className='h-30 text-gray-600 dark:text-white' onClick={()=> playAudio(v.preview,v.name,"",v.voice_id)}/>

 }

 <div className='ml-2'>
   <p className='m-0 text-xl pt-2 text-gray-600 dark:text-white'>{v.name}</p>
   <div className='grid lg:grid-cols-3  gap-2 text-sm text-center'>
     <p className='dark:bg-blue-600 pl-1 pr-1 rounded text-gray-600 border-1 shadow-sm dark:text-white'>{v.age}</p> 
   
   <p className='dark:bg-blue-600 pl-1 pr-1 border-1 text-gray-600 rounded shadow-sm dark:text-white'>{v.accent}</p>
   <p className='dark:bg-blue-600 pl-1 pr-1 border-1 text-gray-600 rounded shadow-sm dark:text-white'>{v.use_case}</p>
   </div>
   </div>
 </div>
))}


</div>


            </div>
            <div className='flex items-center'>

        
            <button type="submit"  className="dark:bg-[#818998] mt-4 justify-end font-Rajdhani text-xl border pt-1 pb-1 pl-3 pr-3 rounded">Send</button>
            {data ? 
            <LineWave
      visible={true}
      height="80"
      width="80"
      ariaLabel="discuss-loading"
      wrapperStyle={{}}
      wrapperClass="discuss-wrapper"
      color="#dd412b"
      backgroundColor="#dd412b"
    
      /> 
      :
      null}
            </div>
            </form>
            <p className='text-red-500 dark:text-red-400'>{error}</p>
            </div>
           
         
            </div>
    
              </Tab>
              <Tab eventKey="Previous" title="Text to Speech - History">
    
    {/* Fetch all the recordings */}
    <div className='grid grid-cols-3 gap-2'>
    {contents && contents.map((c)=>(
      <div className='border-1 p-2 rounded shadow-sm'>
           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-mic" viewBox="0 0 16 16">
  <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"/>
  <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3"/>
</svg>        <p className='font-Rajdhani mt-2 '><span className='border-1 pl-1 pr-1 rounded shadow-sm dark:border-none dark:bg-blue-600'>{c.voice}</span></p>
<p className='font-Rajdhani line-clamp-2'>{c.text}</p>
<div className='flex justify-between '>



<MdOutlineCloudDownload onClick={() =>{
  saveAs(c.audio_url ? c.audio_url : null)
}} className='cursor-pointer' size={25} />




{isPlaying && currentTime !== duration && c.name === spec ? 
<MdOutlinePause size={25} className="cursor-pointer" onClick={()=> playAudio(c.audio_url,c.text,"",c.name)}/>

:
<MdOutlinePlayArrow size={25}  className="cursor-pointer" onClick={()=> playAudio(c.audio_url,c.text,"",c.name)}/>

}

<MdDeleteOutline size={25} className='cursor-pointer' onClick={() => handleDelete(c.name)}/>


</div>
  </div>
 
 ))}
   
    </div>
    
    
              </Tab>
            
            </Tabs>
    
    
        
         
    <div>
    
      
    </div>
    
    
    
    
 
    <div className='fixed inset-x-0 backdrop-blur-md bottom-0 z-10 md:left-64 font-Rajdhani border-t '>

{/* <AudioPlayer  src={result ? result.url :audioPlay} autoplay showDownloadProgress showFilledProgress customAdditionalControls={[]}  showJumpControls={false}/>
     */}
    <div className='player shadow-t text-center w-full pl-5 pr-5   ' style={{display:player}}>
    <div className='flex justify-end'>
    <MdOutlineClose size={25} className='cursor-pointer' onClick={() => setPlayer("none")} />
    </div>
    <p className='line-clamp-1 m-0'>{text}</p>

   

      <div className='flex justify-center align-items-center '>
        <button onClick={backwardBy5}>
      <TbRewindBackward5 size={25} className='text-gray-600 dark:text-white hover:text-gray-700'/>
      </button>
    
      {/* <button>
      <MdOutlinePlayCircleFilled size={70} audioElem={audioElem} className='m-2 content-center text-gray-600 dark:text-white hover:text-gray-700' onClick={() => {(disp)==="" ? setDisp("none") : setDisp("") || setDisplay("none")} } style={{display:displ}}/>
      </button> */}
      {isPlaying ? 
  

      <button onClick={playPause}>
        <MdOutlinePauseCircleFilled  size={70} audioElem={audioElem} className='m-2  content-center text-gray-600 dark:text-white hover:text-gray-700' />
      </button>
:
<button onClick={playPause}>
<MdOutlinePlayCircleFilled size={70} audioElem={audioElem} className='m-2 content-center text-gray-600 dark:text-white hover:text-gray-700' />
</button> 
}
      <button onClick={forwardBy5}>
      <TbRewindForward5 size={25}  className='text-gray-600 mr-2 dark:text-white'/>
     </button>
     <div className='flex align-items-center '>
     <p className='text-xl mt-3 pl-1 pr-2'>{currentTime ? Math.round(currentTime) : "0"}:{duration ? Math.round(duration) : "0"}</p>
     </div>
  
     {/* audio main elemet */}
  
     <audio src={audioPlay} ref={audioElem} onTimeUpdate={onPlaying} preload="none" />

             <div className="bg-gray-300 dark:bg-white-300 h-2 w-full rounded cursor-pointer" onClick={checkWidth} ref={clickRef}>
          <div className="bg-gray-600 rounded dark:bg-blue-700 h-full " style={{width:`${progressBar && progressBar.progress ? progressBar.progress+"%" : "0%"}`}} ></div>
        </div>
   
       {/* <div >
      <input type="range" onClick={checkWidth} ref={clickRef} className='w-full accent-gray-600 dark:accent-white hover:text-gray-700' value={progressBar && progressBar.progress ? progressBar.progress : null}/>
      </div> */}



        {/* <FaVolumeDown size={25} className='m-2 text-gray-600 dark:text-white' onClick={() => {(vol)==="" ? setVol("none") : setVol("") || setMut("none")} } style={{display:mut}}/> */}
{isMuted ? 
<FaVolumeMute size={25} className='m-2 text-gray-600 dark:text-white cursor-pointer' onClick={handleVolume}/>
:
<FaVolumeDown size={25} className='m-2 text-gray-600 dark:text-white cursor-pointer' onClick={handleVolume}/>
}
{/* <FaVolumeMute size={25} className='m-2 text-gray-600 dark:text-white' onClick={() => {(mut)==="" ? setVol("")  : setVol("none") || setMut("")} } style={{display:vol}}/>
       */}

      
      </div>
    
     
      



  </div>


    </div>

    






        </div>
    
       );
      }else{
        return navigate("/")
      }
}


export default TTS;